import React from "react";
import NotifyConfigWorkspace from "../../components/NotifyConfigWorkspace";

export default function ConfigureNotifyPage() {
  return (
    <NotifyConfigWorkspace
      title="Configure Notifications"
      subtitle="Manage in-app notification templates and org-level email delivery without changing approval workflows."
      eyebrow="Super Admin"
      icon="notifications"
      allowEmailTab
    />
  );
}
